var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88006e-08 3C8.41732e-09 1.34315 1.34315 8.12606e-09 3 1.81501e-08L17 1.0285e-07C18.6569 1.12874e-07 20 1.34315 20 3L20 13C20 14.6569 18.6569 16 17 16L3 16C1.34315 16 9.18526e-08 14.6569 8.14693e-08 13L1.88006e-08 3ZM2 3C2 2.44772 2.44772 2 3 2L17 2C17.5523 2 18 2.44772 18 3L18 3.22654L10 7.84532L2 3.22649L2 3ZM2 5.53589L2 13C2 13.5523 2.44772 14 3 14L17 14C17.5523 14 18 13.5523 18 13L18 5.53594L10.5155 9.85714C10.4841 9.87598 10.4518 9.89303 10.4187 9.90825C10.2847 9.97018 10.1428 9.99997 10.0024 10.0002C9.85854 10.0006 9.71294 9.97005 9.57583 9.90564C9.54484 9.89116 9.51454 9.87506 9.48506 9.85739L2 5.53589Z",
    fill: "#032436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.e166e6c1a92d29f6719e072d9b623956.svg";
export { ForwardRef as ReactComponent };